import { hot } from 'react-hot-loader/root';
import Component from './asset-redux';

export default hot(Component);
